export const travelPackages = [
  {
    id: 1,
    title: "Greek Island Hopper",
    destination: "Greece",
    duration: "10 Days / 9 Nights",
    groupSize: "2-12 People",
    price: 2499,
    originalPrice: 3200,
    image: "https://readdy.ai/api/search-image?query=Greek%20islands%20Santorini%20Mykonos%20crystal%20blue%20water%20white%20buildings%20sailing%20boat%20summer%20Mediterranean%20vibrant%20colorful%20paradise&width=800&height=500&seq=pkg1&orientation=landscape",
    category: "Adventure",
    rating: 4.9,
    reviews: 342,
    includes: ["Flights", "Hotels", "Breakfast", "Island Ferry", "Tour Guide"],
    highlights: "Santorini, Mykonos, Crete, Rhodes",
    badge: "Best Seller",
  },
  {
    id: 2,
    title: "Bali Bliss Retreat",
    destination: "Indonesia",
    duration: "8 Days / 7 Nights",
    groupSize: "2-8 People",
    price: 1599,
    originalPrice: 2100,
    image: "https://readdy.ai/api/search-image?query=Bali%20Indonesia%20luxury%20villa%20infinity%20pool%20jungle%20tropical%20lush%20green%20rice%20terraces%20spa%20wellness%20retreat%20serene%20peaceful&width=800&height=500&seq=pkg2&orientation=landscape",
    category: "Luxury",
    rating: 4.8,
    reviews: 518,
    includes: ["Flights", "Villa Stay", "All Meals", "Spa Sessions", "Private Driver"],
    highlights: "Ubud, Seminyak, Nusa Penida, Kuta",
    badge: "Top Rated",
  },
  {
    id: 3,
    title: "African Safari Adventure",
    destination: "Kenya & Tanzania",
    duration: "12 Days / 11 Nights",
    groupSize: "4-16 People",
    price: 3999,
    originalPrice: 5200,
    image: "https://readdy.ai/api/search-image?query=Africa%20safari%20jeep%20game%20drive%20lions%20elephants%20savanna%20golden%20sunset%20Masai%20Mara%20wildlife%20adventure%20dramatic%20landscape&width=800&height=500&seq=pkg3&orientation=landscape",
    category: "Adventure",
    rating: 5.0,
    reviews: 189,
    includes: ["Flights", "Safari Lodge", "All Meals", "Game Drives", "Park Fees"],
    highlights: "Masai Mara, Serengeti, Ngorongoro, Amboseli",
    badge: "Premium",
  },
  {
    id: 4,
    title: "Japan Cherry Blossom Tour",
    destination: "Japan",
    duration: "14 Days / 13 Nights",
    groupSize: "2-20 People",
    price: 3299,
    originalPrice: 4100,
    image: "https://readdy.ai/api/search-image?query=Japan%20cherry%20blossom%20sakura%20Tokyo%20Kyoto%20Mount%20Fuji%20traditional%20culture%20temples%20gardens%20spring%20pink%20flowers%20beautiful&width=800&height=500&seq=pkg4&orientation=landscape",
    category: "Cultural",
    rating: 4.9,
    reviews: 427,
    includes: ["Flights", "Hotels", "Breakfast", "Bullet Train Pass", "Tour Guide"],
    highlights: "Tokyo, Kyoto, Osaka, Hiroshima, Nara",
    badge: "Seasonal",
  },
  {
    id: 5,
    title: "Maldives Luxury Escape",
    destination: "Maldives",
    duration: "7 Days / 6 Nights",
    groupSize: "2 People",
    price: 4999,
    originalPrice: 6500,
    image: "https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20bungalow%20private%20pool%20crystal%20clear%20turquoise%20water%20white%20sand%20beach%20romantic%20sunset%20couple%20paradise&width=800&height=500&seq=pkg5&orientation=landscape",
    category: "Luxury",
    rating: 5.0,
    reviews: 276,
    includes: ["Flights", "Overwater Villa", "All Inclusive", "Seaplane Transfer", "Snorkeling"],
    highlights: "Private Atoll, Coral Reefs, Sunset Cruises",
    badge: "Honeymoon",
  },
  {
    id: 6,
    title: "Machu Picchu Explorer",
    destination: "Peru",
    duration: "9 Days / 8 Nights",
    groupSize: "4-14 People",
    price: 2799,
    originalPrice: 3600,
    image: "https://readdy.ai/api/search-image?query=Machu%20Picchu%20Peru%20Inca%20trail%20trekking%20ancient%20ruins%20mountain%20peaks%20misty%20clouds%20adventure%20hiking%20dramatic%20landscape&width=800&height=500&seq=pkg6&orientation=landscape",
    category: "Adventure",
    rating: 4.8,
    reviews: 312,
    includes: ["Flights", "Hotels", "Breakfast", "Inca Trail Permit", "Expert Guide"],
    highlights: "Lima, Cusco, Sacred Valley, Machu Picchu",
    badge: "Adventure",
  },
];

export const packageCategories = ["All", "Adventure", "Luxury", "Cultural"];
